import { render, staticRenderFns } from "./AddOurFeatures.vue?vue&type=template&id=0162ebc0&scoped=true&"
import script from "./AddOurFeatures.vue?vue&type=script&lang=js&"
export * from "./AddOurFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0162ebc0",
  null
  
)

export default component.exports